import React, { useState, useEffect } from 'react';
import SectionTitle from '../templates/SectionTitle';
import RankingPodium from '../templates/RankingPodium';
import RankingListItem from '../templates/RankingListItem';
import { btsApi } from '../services/btsApi';
import BtsTermsBox from '../templates/BtsTermsBox';
import { rankingTerms } from '../data/mockData';
import './RankingPage.css';
import './TeamPage.css';
const IS_PROD = process.env.REACT_APP_ENV === 'prod';
const log = (...args) => { if (!IS_PROD) console.log(...args); };

const RankingPage = ({ showPopup }) => {
  const [top3, setTop3] = useState([]);
  const [rest, setRest] = useState([]);
  const [myTeam, setMyTeam] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchRanking = async () => {
      try {
        log('[BTS Ranking] Fetching ranking...');

        const [rankRes, myTeamRes] = await Promise.all([
          btsApi.getRanking(20),
          btsApi.getMyTeamRanking(),
        ]);

        log('[BTS Ranking] Ranking result:', rankRes);
        log('[BTS Ranking] My team result:', myTeamRes);

        const teams = rankRes?.data || [];

        const mappedTop3 = teams.slice(0, 3).map((t) => ({
          rank: t.rank,
          name: t.members?.[0]?.display_name || 'ทีม',
          team: t.party_name,
          points: Math.floor(t.total_tickets || 0),
          avatar: '👥',
          pictureUrl: t.members?.[0]?.picture_url || null,
        }));

        const mappedRest = teams.slice(3).map((t) => ({
          rank: t.rank,
          name: t.members?.[0]?.display_name || 'ทีม',
          team: t.party_name,
          points: Math.floor(t.total_tickets || 0),
          avatar: '👥',
          pictureUrl: t.members?.[0]?.picture_url || null,
        }));

        setTop3(mappedTop3);
        setRest(mappedRest);

        const myData = myTeamRes?.data;
        if (myData) {
          setMyTeam({
            rank: myData.rank || '-',
            team: myData.party_name || 'ทีมของฉัน',
            points: Math.floor(myData.total_tickets || 0),
            memberCount: myData.member_count || 0,
          });
        }
      } catch (err) {
        console.error('[BTS Ranking] Error:', err);
        if (showPopup) showPopup('เกิดข้อผิดพลาด', 'ไม่สามารถโหลดอันดับได้');
      } finally {
        setLoading(false);
      }
    };
    fetchRanking();
  }, [showPopup]);

  return (
    <div>
      <SectionTitle icon="🏆">HALL OF FAME</SectionTitle>

      {loading ? (
        <div className="bts-ranking__loading">กำลังโหลด...</div>
      ) : top3.length === 0 && rest.length === 0 ? (
        null
      ) : (
        <>
          {top3.length >= 3 && <RankingPodium top3={top3} />}
          <div className="bts-ranking__list">
            {top3.length < 3 && top3.map((item) => (
              <RankingListItem key={item.rank} item={item} />
            ))}
            {rest.map((item) => (
              <RankingListItem key={item.rank} item={item} />
            ))}
          </div>
        </>
      )}

      {/* Current user */}
      {myTeam && myTeam.memberCount >= 4 ? (
        <div className="bts-ranking__you-card">
          <div className="bts-ranking__you-badge">คุณ</div>
          <div className="bts-ranking__you-rank">{myTeam.rank}</div>
          <div className="bts-ranking__you-avatar">
            {(() => {
              const pic = localStorage.getItem('line_picture_url');
              return pic
                ? <img src={pic} alt="me" className="bts-ranking__you-avatar-img" />
                : '⭐';
            })()}
          </div>
          <div className="bts-ranking__you-info">
            <p className="bts-ranking__you-team">ทีม {myTeam.team}</p>
            {/* <p className="bts-ranking__you-meta">{data.name}</p> */}
          </div>
          <div className="bts-ranking__you-right">
            <span className="bts-ranking__you-points">
              {myTeam.points.toLocaleString()}
            </span>
            <span className="bts-ranking__you-pts-unit">คะแนน</span>
          </div>
        </div>
      ) : !loading && (
        <div className="bts-ranking__not-ranked">
          {/* <div className="bts-ranking__not-ranked-icon">🏅</div> */}
          <p className="bts-ranking__not-ranked-title">ยังไม่ได้ถูกจัดอันดับ</p>
          <p className="bts-ranking__not-ranked-desc">
            {!myTeam
              ? 'สร้างทีมและชวนเพื่อนให้ครบ 4 คน เพื่อเข้าร่วมจัดอันดับ!'
              : `ทีมของท่านมีสมาชิก ${myTeam.memberCount}/4 คน — ชวนเพื่อนอีก ${4 - myTeam.memberCount} คน!`
            }
          </p>
        </div>
      )}

      <BtsTermsBox title="เงื่อนไข : การรับรางวัล" terms={rankingTerms} />

      <div className="bts-ranking__spacer" />
    </div>
  );
};

export default RankingPage;
